import Api from 'services/Api';

const mutataionTypes = {
    UPDATE: 'UPDATE',
    RESET: 'RESET',
    RESET_TYPE: 'RESET_TYPE',
    UPDATE_CLAIMS: 'UPDATE_CLAIMS',
};

const initialState = () => {
    return {
        diseaseOrAccident: null,
        diseaseType: null,
        accidentType: null,
        claimType: null,
        discountRate: -.25,
        from: 'dayOne',
        to: 'paid',
        claims: [],
        range: [-0.20, 0.20],
        searchTerm: '',
        calculating: false,
        hasNoClaims: false,
        includeInTable: 'all'
    };
};

// Initial State
const state = initialState();

// Calculate the absolute average
function getAverageDifference(state, getters) {
    let difference = getters.claims.map((claim) => {
        return Math.abs(claim.to - claim.from)
    });

    let average = difference.reduce((total, value) => total + value, 0);

    return (average / getters.claims.length);
}

// Getters
const getters = {
    calculating: state => state.calculating,
    diseaseOrAccident: state => state.diseaseOrAccident,
    diseaseType: state => state.diseaseType,
    accidentType: state => state.accidentType,
    claimType: state => state.claimType,
    discountRate: state => state.discountRate,
    from: state => state.from,
    to: state => state.to,
    range: state => state.range,
    claims: state => state.claims
        // Only allow paid claim when comparing paid values.
        .filter(claim => claim.outcome === 'Paid' || (state.from !== 'paid' && state.to !== 'paid'))
        .map(claim => {
            let difference = claim[state.to] - claim[state.from];
            return {
                id: claim.id,
                type: claim.type,
                reference: claim.reference,
                claimHandler: claim.claimsHandler,
                from: parseFloat(claim[state.from]),
                to: parseFloat(claim[state.to]),
                difference: parseFloat(difference),
                percent: difference / parseFloat(claim[state.from]),
            }
        }),
    hasClaims: state => !!(state.claims && state.claims.length),
    hasNoClaims: state => state.hasNoClaims,
    hasPaidClaims: state => {
        if (!state.claims || state.claims.length === 0) {
            return false;
        }
        return !!state.claims.filter(claim => claim.outcome === 'Paid' || (state.from !== 'paid' && state.to !== 'paid')).length;
    },
    numberOfPaid: state => {
        if (!state.claims || state.claims.length === 0) {
            return 0;
        }
        return state.claims.filter(claim => claim.outcome === 'Paid' || (state.from !== 'paid' && state.to !== 'paid')).length;
    },
    tableClaims: (state, getters) => getters.claims
        .filter(claim => {
            switch (state.includeInTable) {
                case 'all':
                    return true;
                case 'under':
                    return claim.percent < state.range[0];
                case 'over':
                    return claim.percent > state.range[1];
                case 'inside':
                    return claim.percent >= state.range[0] && claim.percent <= state.range[1];
                case 'outside':
                    return claim.percent < state.range[0] || claim.percent > state.range[1];
            }
        })
        .sort((a, b) => Math.abs(b.difference) - Math.abs(a.difference)),
    totalClaims: state => state.claims.length,
    averageFrom: (state, getters) => getters.claims.reduce((total, claim) => total + claim.from, 0) / getters.claims.length,
    averageTo: (state, getters) => getters.claims.reduce((total, claim) => total + claim.to, 0) / getters.claims.length,
    averageDifference: (state, getters) => getAverageDifference(state, getters),
    includeInTable: state=> state.includeInTable,
};

// Actions
const actions = {
    update({commit}, {key, value}) {
        commit(mutataionTypes.UPDATE, {key, value});
    },
    resetType({commit}, {key}) {
        commit(mutataionTypes.RESET_TYPE, {key});
    },
    calculate({commit, state, dispatch}) {

        let injuryType = null;

        switch (state.diseaseOrAccident) {
            case 'disease':
                injuryType = state.diseaseType;
                break;
            case 'accident':
                injuryType = state.accidentType;
                break;
        }

        return dispatch('update', {key: 'calculating', value: true})
            .then(() => Api.dashboards.reserving.compareAssessment(
                state.diseaseOrAccident,
                injuryType,
                state.claimType,
                state.discountRate,
                state.from,
                state.to
            ))
            .then(results => commit(mutataionTypes.UPDATE_CLAIMS, results))
            .then(() => dispatch('update', {key: 'calculating', value: false}));
    },
    search({commit}, term) {
        commit(mutataionTypes.UPDATE, {key: 'searchTerm', value: term});
    },
    resetSearch({commit}) {
        commit(mutataionTypes.UPDATE, {key: 'searchTerm', value: ''});
    }
};

// Mutations
const mutations = {
    [mutataionTypes.UPDATE](state, {key, value}) {
        state[key] = value;
        if (key==='calculating' && value) {
            state.hasNoClaims = false;
        }
    },
    [mutataionTypes.RESET_TYPE](state, {key, value}) {
        state[key] = value;

        switch (key) {
            case 'accidentType':
                state.accidentType = null;
                break;
            case 'diseaseType':
                state.diseaseType = null;
                break;
        }
    },
    [mutataionTypes.UPDATE_CLAIMS](state, claims) {
        state.claims = claims;
        state.hasNoClaims = !claims || claims.length === 0;
    },
    [mutataionTypes.RESET](state) {
        Object.assign(state, initialState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reserves/compare.js